export const uk = {
    'add-creatives': 'Добавить выбранные',
    'cancel-and-return': 'Отмена'
};
